import { set, get } from 'lodash';
import basicChartMixin from './chart-basic.mixin';

export default {
  name: 'ChartLineMixin',
  mixins: [basicChartMixin],
  methods: {
    getLineChartOptions() {
      const options = this.getBasicChartOptions('line');

      const rotation = parseFloat(get(options, 'xAxis.axisLabel.rotate', 0));
      set(options, 'grid.bottom', 20 + rotation * 1.7);

      return options;
    },
  },
};
